export interface ProgressEntry {
  date: string;
  handicap?: number;
  driverDistance?: number;
  sevenIronDistance?: number;
  notes?: string;
}

/** Returns stored entries only. Never synthesizes a six-month history. */
export function loadStoredProgress(raw: string | null | undefined): ProgressEntry[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
